/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { TextCellModel } from "./TextCellModel";
import { markType } from "igniteui-react-core";
import { ContentCellModelHelper } from "./ContentCellModelHelper";
/**
 * @hidden
 */
var TextCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextCellPresenter, _super);
    function TextCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(TextCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    TextCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (a.ar) {
            if (a.aw(TextCellModel.kf) || a.aw(CellModel.fe)) {
                if (b.kh != null) {
                    b.ie = b.kh;
                }
                else {
                    if (b.gh == null) {
                        b.ie = "";
                    }
                    else {
                        b.ie = b.gh.toString();
                    }
                }
                this.d.b4.setRawText(b.ie);
            }
            ContentCellModelHelper.a(this.a.w, b, this.a.z, this.d.b4, this.a);
        }
    };
    TextCellPresenter.$t = markType(TextCellPresenter, 'TextCellPresenter', CellPresenterBase.$);
    return TextCellPresenter;
}(CellPresenterBase));
export { TextCellPresenter };
//# sourceMappingURL=TextCellPresenter.js.map
